<section class="vc-email-account">
  @if (hasHeader) {
    <header class="vc-email-account__header">
      @if (titleKey) {
        <h4>{{ titleKey | translate }}</h4>
      }
      @if (descriptionKey) {
        <p>{{ descriptionKey | translate }}</p>
      }
    </header>
  }

  @if (loading) {
    <p class="vc-email-account__state">{{ 'COMMON.LOADING' | translate }}</p>
  } @else {
    <div class="vc-email-account__topbar">
      <div class="vc-email-account__top-card">
        <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.ENABLED' | translate }}</span>
        <div class="vc-email-account__toggle-row">
          <p-checkbox
            [(ngModel)]="account.enabled"
            [binary]="true"
            [inputId]="'email-enabled-' + scope"
          ></p-checkbox>
          <label [for]="'email-enabled-' + scope">
            {{ account.enabled ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate) }}
          </label>
        </div>
      </div>

      <label class="vc-email-account__top-card vc-email-account__top-card--provider">
        <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.PRESET_LABEL' | translate }}</span>
        <p-select
          [options]="presetOptions"
          [(ngModel)]="account.preset"
          (ngModelChange)="onPresetChange()"
          optionLabel="labelKey"
          optionValue="value"
          [appendTo]="'body'"
          styleClass="vc-email-account__select"
          fluid
        >
          <ng-template let-option pTemplate="item">
            {{ option.labelKey | translate }}
          </ng-template>
          <ng-template let-option pTemplate="selectedItem">
            {{ option?.labelKey ? (option.labelKey | translate) : '' }}
          </ng-template>
        </p-select>
      </label>

      <div
        class="vc-email-account__top-card vc-email-account__top-card--status"
        [class.vc-email-account__top-card--success]="account.configured"
      >
        <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.PROVIDER_STATUS' | translate }}</span>
        <strong>{{ configurationStatusKey | translate }}</strong>
        <p>{{ configurationStatusHelpKey | translate }}</p>
      </div>
    </div>

    @if (scopeNoteKey) {
      <div class="vc-email-account__scope-note">
        <strong>{{ 'ADMIN.EMAIL_ACCOUNTS.TITLE' | translate }}</strong>
        <p>{{ scopeNoteKey | translate }}</p>
      </div>
    }

    <div class="vc-email-account__sections-grid">
      @if (isManagedPreset()) {
        <section class="vc-email-account__section">
          <header class="vc-email-account__section-header">
            <div>
              <h5>{{ 'ADMIN.EMAIL_ACCOUNTS.TECHNICAL_SECTION_TITLE' | translate }}</h5>
              <p>{{ 'ADMIN.EMAIL_ACCOUNTS.TECHNICAL_SECTION_DESCRIPTION' | translate }}</p>
            </div>
          </header>

          <div class="vc-email-account__managed-card">
            <div class="vc-email-account__managed-copy">
              <strong>{{ 'ADMIN.EMAIL_ACCOUNTS.PRESET_HELP_TITLE' | translate }}</strong>
              <p>{{ 'ADMIN.EMAIL_ACCOUNTS.PRESET_HELP_BODY' | translate }}</p>
              @if (account.preset === 'GMAIL') {
                <p>{{ 'ADMIN.EMAIL_ACCOUNTS.GMAIL_APP_PASSWORD' | translate }}</p>
              }
            </div>

            <dl class="vc-email-account__managed-grid">
              <div>
                <dt>{{ 'ADMIN.EMAIL_ACCOUNTS.HOST' | translate }}</dt>
                <dd>{{ account.host || '-' }}</dd>
              </div>
              <div>
                <dt>{{ 'ADMIN.EMAIL_ACCOUNTS.PORT' | translate }}</dt>
                <dd>{{ account.port || '-' }}</dd>
              </div>
              <div>
                <dt>{{ 'ADMIN.EMAIL_ACCOUNTS.SECURE' | translate }}</dt>
                <dd>{{ account.secure ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate) }}</dd>
              </div>
            </dl>
          </div>
        </section>
      } @else {
        <section class="vc-email-account__section">
          <header class="vc-email-account__section-header">
            <div>
              <h5>{{ 'ADMIN.EMAIL_ACCOUNTS.TECHNICAL_SECTION_TITLE' | translate }}</h5>
              <p>{{ 'ADMIN.EMAIL_ACCOUNTS.TECHNICAL_SECTION_DESCRIPTION' | translate }}</p>
            </div>
          </header>

          <div class="vc-email-account__section-grid vc-email-account__section-grid--technical">
            <label class="vc-email-account__field">
              <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.HOST' | translate }}</span>
              <input class="vc-email-account__input" pInputText [(ngModel)]="account.host" />
            </label>

            <label class="vc-email-account__field vc-email-account__field--compact">
              <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.PORT' | translate }}</span>
              <input class="vc-email-account__input" pInputText type="number" [(ngModel)]="account.port" />
            </label>

            <div class="vc-email-account__toggle-panel">
              <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.SECURE' | translate }}</span>
              <div class="vc-email-account__toggle-row">
                <p-checkbox
                  [(ngModel)]="account.secure"
                  [binary]="true"
                  [inputId]="'email-secure-' + scope"
                ></p-checkbox>
                <label [for]="'email-secure-' + scope">
                  {{ account.secure ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate) }}
                </label>
              </div>
            </div>
          </div>
        </section>
      }

      <section class="vc-email-account__section">
        <header class="vc-email-account__section-header">
          <div>
            <h5>{{ 'ADMIN.EMAIL_ACCOUNTS.CREDENTIALS_SECTION_TITLE' | translate }}</h5>
            <p>{{ 'ADMIN.EMAIL_ACCOUNTS.CREDENTIALS_SECTION_DESCRIPTION' | translate }}</p>
          </div>
        </header>

        <div class="vc-email-account__section-grid vc-email-account__section-grid--credentials">
          <label class="vc-email-account__field">
            <span class="vc-email-account__label">
              {{
                (isManagedPreset()
                  ? 'ADMIN.EMAIL_ACCOUNTS.SERVICE_USER'
                  : 'ADMIN.EMAIL_ACCOUNTS.USERNAME')
                  | translate
              }}
            </span>
            <input
              class="vc-email-account__input"
              pInputText
              [type]="isManagedPreset() ? 'email' : 'text'"
              [(ngModel)]="account.username"
            />
          </label>

          <label class="vc-email-account__field">
            <span class="vc-email-account__label">
              {{
                (isManagedPreset()
                  ? 'ADMIN.EMAIL_ACCOUNTS.SERVICE_PASSWORD'
                  : 'ADMIN.EMAIL_ACCOUNTS.PASSWORD')
                  | translate
              }}
            </span>
            <input class="vc-email-account__input" pInputText type="password" [(ngModel)]="account.password" />
            @if (account.has_password) {
              <small class="vc-email-account__help">{{ 'ADMIN.EMAIL_ACCOUNTS.PASSWORD_STORED' | translate }}</small>
            }
          </label>
        </div>
      </section>

      <section class="vc-email-account__section">
        <header class="vc-email-account__section-header">
          <div>
            <h5>{{ 'ADMIN.EMAIL_ACCOUNTS.SENDER_SECTION_TITLE' | translate }}</h5>
            <p>{{ 'ADMIN.EMAIL_ACCOUNTS.SENDER_SECTION_DESCRIPTION' | translate }}</p>
          </div>
        </header>

        <div
          class="vc-email-account__section-grid"
          [class.vc-email-account__section-grid--sender-managed]="isManagedPreset()"
          [class.vc-email-account__section-grid--sender-custom]="!isManagedPreset()"
        >
          @if (isManagedPreset()) {
            <label class="vc-email-account__field vc-email-account__field--wide">
              <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.FROM_COMBINED' | translate }}</span>
              <input class="vc-email-account__input" pInputText [(ngModel)]="providerFromValue" />
              <small class="vc-email-account__help">{{ 'ADMIN.EMAIL_ACCOUNTS.FROM_COMBINED_HELP' | translate }}</small>
            </label>
          } @else {
            <label class="vc-email-account__field">
              <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.FROM_NAME' | translate }}</span>
              <input class="vc-email-account__input" pInputText [(ngModel)]="account.from_name" />
            </label>

            <label class="vc-email-account__field">
              <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.FROM_EMAIL' | translate }}</span>
              <input class="vc-email-account__input" pInputText type="email" [(ngModel)]="account.from_email" />
            </label>
          }

          <label class="vc-email-account__field vc-email-account__field--reply">
            <span class="vc-email-account__label">{{ 'ADMIN.EMAIL_ACCOUNTS.REPLY_TO' | translate }}</span>
            <input class="vc-email-account__input" pInputText type="email" [(ngModel)]="account.reply_to_email" />
          </label>
        </div>
      </section>

      <section class="vc-email-account__section">
        <header class="vc-email-account__section-header">
          <div>
            <h5>{{ 'ADMIN.EMAIL_ACCOUNTS.TEST_SECTION_TITLE' | translate }}</h5>
            <p>{{ 'ADMIN.EMAIL_ACCOUNTS.TEST_SECTION_DESCRIPTION' | translate }}</p>
          </div>
        </header>

        <div class="vc-email-account__test-layout">
          <div
            class="vc-email-account__status-card"
            [class.vc-email-account__status-card--success]="lastTestTone === 'success'"
            [class.vc-email-account__status-card--error]="lastTestTone === 'error'"
          >
            @if (account.last_test_result) {
              <strong>{{ account.last_test_result }}</strong>
              @if (account.last_tested_at) {
                <span>
                  {{ 'ADMIN.EMAIL_ACCOUNTS.LAST_TESTED_AT' | translate }}:
                  {{ account.last_tested_at | date: 'short' }}
                </span>
              }
            } @else {
              <strong>{{ configurationStatusKey | translate }}</strong>
              <span>{{ 'ADMIN.EMAIL_ACCOUNTS.TEST_HINT' | translate }}</span>
            }
          </div>
        </div>
      </section>
    </div>

    <div class="vc-email-account__actions vc-email-account__actions--footer">
      <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="save()">
      {{ 'COMMON.SAVE' | translate }}
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-send"
        class="p-button-outlined"
        [disabled]="testing"
        (click)="openTestDialog()"
      >
        {{ 'ADMIN.EMAIL_ACCOUNTS.TEST' | translate }}
      </button>
    </div>

    <p-dialog
      [(visible)]="testDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '30rem', maxWidth: '95vw' }"
      [closable]="!testing"
      [closeOnEscape]="!testing"
      [dismissableMask]="!testing"
      [header]="'ADMIN.EMAIL_ACCOUNTS.TEST_SECTION_TITLE' | translate"
    >
      <div class="vc-email-account__dialog-content">
        <label class="vc-email-account__field">
          <span class="vc-email-account__label">
            {{
              (isManagedPreset()
                ? 'ADMIN.EMAIL_ACCOUNTS.TEST_TO'
                : 'ADMIN.EMAIL_ACCOUNTS.TEST_RECIPIENT')
                | translate
            }}
          </span>
          <input class="vc-email-account__input" pInputText type="email" [(ngModel)]="testDialogRecipient" />
          <small class="vc-email-account__help">{{ 'ADMIN.EMAIL_ACCOUNTS.TEST_HINT' | translate }}</small>
        </label>
      </div>

      <ng-template pTemplate="footer">
        <div class="vc-email-account__dialog-actions">
          <button
            pButton
            type="button"
            class="p-button-text"
            [disabled]="testing"
            (click)="closeTestDialog()"
          >
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button pButton type="button" icon="pi pi-send" [disabled]="testing" (click)="testConnection()">
            {{ 'ADMIN.EMAIL_ACCOUNTS.TEST' | translate }}
          </button>
        </div>
      </ng-template>
    </p-dialog>
  }
</section>
